<template>
  <helper-layout :loaded="mx_loaded">
    <v-card class="details-wrap">
      <div class="detail-title" :style="`color:${getPrimary(color)}`">
        {{ $t("Views.Order.orderDetails") }}
      </div>
      <v-layout>
        <v-flex xs5>
          <!-- 订单号 -->
          <div class="detailWrap">
            <label class="width-60">{{ $t("Views.Order.orderNum") }}</label><label>:</label>
            <span>{{ detail.number }}</span>
          </div>
          <!-- 销售 -->
          <div class="detailWrap">
            <label class="width-60">{{ $t("Views.Order.sale_label") }}</label><label>:</label>
            <span>{{ detail.salesName||'--' }}</span>
          </div>
          <!-- 消费税额 -->
          <div class="detailWrap">
            <label class="width-60">{{ $t("Views.Order.consumptionTax") }}</label><label>:</label>
            <span>{{ currencyMap[detail.currencyName] }}{{ formatorderPrice(detail.targetCurrencyTaxRateAmount) }}</span>
          </div>
          <!-- 入金方法   -->
          <div v-if="detail.settlementType==='PrePayment'" class="detailWrap">
            <label class="width-60">{{ $t("Views.Order.depositMehtods") }}</label><label>:</label>
            <span>{{ $t("Views.Order.Prepayment") }}</span>
          </div>
        </v-flex>
        <v-flex xs5>
          <!-- 下单日 -->
          <div class="detailWrap">
            <label class="width-100">{{ $t("Views.Order.order_time_label") }}</label><label>:</label>
            <span>{{ detail.creationTime | dateFmt }}</span>
          </div>
          <!-- 结算方式 -->
          <div class="detailWrap">
            <label class="width-100">{{ $t("Views.Order.settlementMethod") }}</label><label>:</label>
            <span>{{ detail.settlementType && getEnumsStatus("settlementType", detail.settlementType) }}</span>
          </div>
          <!-- 其他科目金额 -->
          <div class="detailWrap">
            <label class="width-100">{{ $t("Views.Order.otherAmount") }}</label><label>:</label>
            <span :class="detail.targetCurrencyOtherPrice<0?'oRed':''">{{ currencyMap[detail.currencyName] }}{{ formatorderPrice(detail.targetCurrencyOtherPrice) || "--" }}</span>
            <span>({{ $t("Views.Order.otherTax") }}：<span :class="detail.targetCurrencyOtherTaxRateAmount<0?'oRed':''">{{ currencyMap[detail.currencyName] }}{{ formatorderPrice(detail.targetCurrencyOtherTaxRateAmount)|| "--" }} </span>)</span>
          </div>
        </v-flex>
        <v-flex xs5>
          <!-- 客户信息 -->
          <div class="detailWrap">
            <label class="width-75">{{ $t("Views.Order.customer_info_label") }}</label><label>:</label>
            <span>
              {{ detail.customer && detail.customer.name }}
              {{ detail.customer && formatSerialNum(detail.customer.serialNumber) }}
              {{ detail.customer && formatSerialNum(detail.customer.newSerialNumber) }}</span>
          </div>
          <!-- 订单金额 -->
          <div class="detailWrap">
            <label class="width-75">{{ $t("Views.Order.orderAmount") }}</label><label>:</label>
            <span>{{ currencyMap[detail.currencyName] }}{{ formatorderPrice(detail.targetCurrencyOrderPrice ) }}</span>
          </div>
          <!-- 应付金额 -->
          <div class="detailWrap">
            <label class="width-75">{{ $t("Views.Order.dueCharge") }}</label><label>:</label>
            <span>{{ currencyMap[detail.currencyName] }}{{ formatorderPrice(detail.targetCurrencyPrice) || "--" }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- 入金详情 结算方式为现结才显示-->
    <v-card v-if="detail.settlementType==='PaymentNow'" class="details-wrap margin-top-20">
      <div class="detail-title" :style="`color:${getPrimary(color)}`">
        {{ $t("Views.Order.chargeDetail") }}
      </div>
      <v-layout>
        <material-table :headers="depositHeader" :has-total="true" :items="depositSource" :has-paginate="false" class="sum_pad_table">
          <template slot="table-footer">
            <td />
            <td />
            <td class="amount-td">
              {{ currencyMap[detail.currencyName] }} {{ formatorderPrice(sumArr(depositSource,"amount")) }}
              <span class="total">（{{ $t("Views.Order.total") }}）</span>
            </td>
          </template>
        </material-table>
      </v-layout>
      <div v-if="refundSource.length>0" class="detail-title" :style="`color:${getPrimary(color)}`">
        {{ $t("Views.Order.refundDetails") }}
      </div>
      <v-layout v-if="refundSource.length>0">
        <material-table :headers="refundHeader" :items="refundSource" :has-paginate="false" class="refund_pad_table">
          <template slot="table-footer">
            <td />
            <td class="amount-td">
              {{ currencyMap[detail.currencyName] }}{{ formatorderPrice(sumArr(refundSource,"amount")) }}
              <span class="amount total">（{{ $t("Views.Order.total") }}）</span>
            </td>
            <td />
          </template>
        </material-table>
      </v-layout>
    </v-card>
    <!-- 配货详情 -->
    <v-card class="details-wrap margin-top-20">
      <div class="detail-title" :style="`color:${getPrimary(color)}`">
        {{ $t("Core.Route.allocationDistribute") }}
      </div>
      <v-layout>
        <v-flex xs4>
          <div class="detailWrap">
            <label class="width-100">{{ $t("Views.Order.ExpecteDeliveryDate") }}</label><label>:</label>
            <span>{{ detail.expectShipDate ? formatDate(detail.expectShipDate) : "--" }}
            </span>
          </div>
        </v-flex>
        <v-flex xs5>
          <div class="detailWrap">
            <label class="width-100">{{ $t("Views.Order.deliveryDate") }}</label><label>:</label>
            <span>{{ detail.expectDeliveryTime ? getEnumsStatus("expectDeliveryTime", detail.expectDeliveryTime) : "--" }}
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="form" v-model="valid">
        <v-layout align-center>
          <!-- 出货日 -->
          <v-flex xs5 class="flex-fix">
            <div class="detailWrap input-required">
              <label class="width-100" for="">{{ $t('Views.Order.shipmentDate') }}</label><label>:</label>
            </div>
            <material-dateTime
              v-model="form.shipTime"
              class="margin-left-12"
              display-format="YYYY-MM-DD"
              type="date"
              no-title
              :rules="shipTimeRules"
              label=""
              :placeholder="$t('Views.Customer.selectSignDate')"
              :min-date="new Date().toDateString()"
            />
          </v-flex>
          <!-- 送达日 -->
          <v-flex xs5 class="flex-fix">
            <div class="detailWrap input-required">
              <label class="width-100" for="">{{ $t('Views.Order.shipDate') }}</label><label>:</label>
            </div>
            <material-dateTime
              v-model="form.shipDate"
              class="margin-left-12"
              display-format="YYYY-MM-DD"
              type="date"
              no-title
              :rules="shipDateRules"
              label=""
              :placeholder="$t('Views.Customer.selectSignDate')"
              :min-date="new Date().toDateString()"
            />
          </v-flex>
          <!-- 送达时间 -->
          <v-flex xs5 class="flex-fix">
            <div class="detailWrap">
              <label class="width-100" for="">{{ $t('Views.Order.deliveryTime') }}</label><label>:</label>
            </div>
            <v-select
              v-model="form.deliveryTime"
              clearable
              class="margin-left-12 select-width"
              :items="deliveryTimeList"
              :item-value="items => items.value"
              :item-text="items => items.label"
              :placeholder="$t('Core.System.pleaseSelect')"
              :rules="deliveryTimeRules"
            />
          </v-flex>
        </v-layout>
      </v-form>
      <div class="detail-title margin-top-20" :style="`color:${getPrimary(color)}`">
        {{ $t("Views.Order.distributionDetail") }}
      </div>
      <material-table
        :headers="deliveryHeaders"
        :items="items"
        :has-paginate="false"
      />
    </v-card>
    <v-layout>
      <v-flex xs12 text-xs-center class="bottom-btn">
        <v-btn color="cancel" outline @click="() => $router.go(-1)">
          {{ $t("Views.Goods.goBack") }}
        </v-btn>
        <!-- :disabled="cantAllocation" -->
        <v-btn v-clickthrottle="{ handle: save, delay: 4000 }" :color="color">
          {{ $t("Views.Customer.save") }}
        </v-btn>
      </v-flex>
    </v-layout>
    <material-dialog
      :width="600"
      :visible="showModal"
      :title="$t('Views.Customer.sure')"
      @cancleFn="cancelDialog"
      @confirmFn="confirmDialog"
    >
      <template>
        <div>
          {{ $t("Views.Order.sureDistribution") }}
        </div>
        <v-form ref="modalForm" v-model="modalValid">
          <v-layout row>
            <v-flex>
              <v-textarea
                v-model="confirmMemo"
                class="input-required"
                :rules="[v => !!v || $t('Views.Order.memoNotEmpty'),
                         v => !!v.trim() || $t('Views.Order.memoNotEmpty')]"
                required
                counter
                maxlength="50"
                name="input-7-1"
                :label="$t('Views.Order.memoNotEmpty')"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </template>
    </material-dialog>
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format, compareAsc } from 'date-fns'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      showModal: false,
      confirmMemo: '',
      modalValid: false,
      items: [],
      valid: false,
      form: {
        shipTime: '',
        shipDate: '',
        deliveryTime: ''
      },
      refundHeader: [
        {
          text: $t('Views.Order.refundDate'),
          value: 'paymentTime',
          type: 'date',
          width: 120
        },
        {
          text: $t('Views.Order.refundAmout'),
          value: 'amount',
          width: 120,
          align: 'left',
          render: (h, params) => {
            return h('div', ` ${this.$util.data.toThousands(params.row.amount)}`)
          }
        },
        {
          align: 'left',
          text: $t('Views.Order.remark'),
          value: 'remark',
          width: 120
        }
      ], // 退款详情header
      refundSource: [], // 退款table
      depositHeader: [// 入金详情的table
        {
          text: $t('Views.Order.depositDate'),
          value: 'paymentTime',
          type: 'date',
          width: 120,
          sortable: false
        }, {
          text: $t('Views.Order.depositMehtods'),
          value: 'paymentMethodName',
          width: 120,
          sortable: false
        }, {
          text: $t('Views.Order.depositTotal'),
          render: (h, params) => {
            return h('div', `${this.currencyMap[this.detail.currencyName]} ${this.$util.data.toThousands(params.row.amount)}`)
          },
          width: 120,
          sortable: false,
          align: 'right'
        }
      ],
      depositSource: [], // 入金data
      deliveryHeaders: [
        {
          text: $t('Views.Order.product'),
          sortable: false,
          value: 'product',
          render: (h, param) => {
            return h('material-img', {
              props: {
                desc: param.row.product.name,
                pictureKey: param.row.product.pictureKey,
                pictureWidth: 40,
                pictureHeight: 40,
                preview: true,
                serialNumber: param.row.product.yayoiSerialNumber,
                capacity: param.row.product.capacity
                // orderPrice: param.row.product.discountPrice,
              }
            })
          }
        },
        // 批号
        {
          text: $t('Views.Order.rodNumber'),
          render: (h, param) => {
            const text = param.row.rodNumber ? param.row.rodNumber : ''
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Order.beforePrice'),
          width: 150,
          sortable: false,
          align: 'right',
          value: 'product.discountPrice',
          type: 'nest',
          prefix: '￥',
          isCurrency: true
        },
        {
          text: $t('Views.Order.orderCount'),
          value: 'orderQuantity',
          sortable: false,
          width: 140
        },
        {
          text: $t('Views.Order.hasDistributionNumber'), // 已配货数
          value: 'allocationQuantity',
          sortable: false,
          width: 140
        },
        {
          text: $t('Views.Order.allocatedNumber'), // 待配货数
          value: 'pendingAllocationQuantity',
          sortable: false,
          width: 140
        },
        { text: $t('Views.Order.distributionNumber'), // 配货数量
          sortable: false,
          align: 'right',
          value: 'quantity',
          // isInputNumber: { type: 'quantity' },
          render: (h, param) => {
            return h('ams-quantity-inputs', {
              props: {
                data: param.row.quantity,
                rules: [
                  v => v <= param.row.pendingAllocationQuantity || $t('Views.Order.warningQuantity')
                ],
                min: 0,
                max: param.row.pendingAllocationQuantity
              },
              on: {
                change: (val) => {
                  if (val === null) return
                  this.$set(this.items[param.index], 'quantity', Number(val))
                }
              }
            })
          },
          width: 200
        }
      ],
      orderId: null,
      detail: {},
      currencyMap: {
        JPY: '¥',
        USD: '$'
      }
    }
  },
  computed: {
    // 送达时间枚举转下拉列表数据
    deliveryTimeList() {
      return [...this.$util.tool.enumToSelect(ENUMS.deliveryTime)]
    },
    color() {
      return this.$store.state.app.color
    },
    ...mapState('order', ['allocationData']),
    // 出货日校验规则
    shipTimeRules() {
      const rules = [
        this.$util.rules.emptyRule(this.$t('Views.Order.shipmentDate'))
      ]
      if (this.form.shipTime && this.form.shipDate) {
        rules.push(
          v => {
            if (compareAsc(this.form.shipTime, this.form.shipDate) !== -1) {
              return this.$t('Views.Order.shipDateMoreThanShipTime')
            } else {
              return true
            }
          }
        )
      }
      return rules
    },
    // 送达日校验规则
    shipDateRules() {
      const rules = [
        this.$util.rules.emptyRule(this.$t('Views.Order.shipDate'))
      ]
      if (this.form.shipTime && this.form.shipDate) {
        rules.push(
          v => {
            if (compareAsc(this.form.shipTime, this.form.shipDate) !== -1) {
              return this.$t('Views.Order.shipDateMoreThanShipTime')
            } else {
              return true
            }
          }
        )
      }
      return rules
    },
    // 送达时间校验规则
    deliveryTimeRules() {
      return []
    }
  },
  watch: {
    'form.shipTime': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && this.form.shipDate) { this.$refs.form.validate() }
      }
    },
    'form.shipDate': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && this.form.shipTime) { this.$refs.form.validate() }
      }
    }
  },
  created() {
    this.orderId = this.$route.query.id
  },
  mounted() {
    this.getPage()
    this.getDetailStockOrder({ id: this.orderId }).then(data => {
      this.detail = data
      this.form.shipDate = this.detail.expectShipDate
      this.form.deliveryTime = this.detail.expectDeliveryTime
      this.depositSource = data.payments.rechargeItems.items
      this.refundSource = data.payments.refundItems.items
    })
  },
  methods: {
    ...mapActions('setting', ['getStaffAllData']),
    ...mapActions('order', ['getAllocationData', 'sureShipProduct', 'getDetailStockOrder']),
    getPage() {
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getAllocationData(this.orderId).then(() => {
        this.items = this.allocationData.items.map((item) => {
          if (item.product) {
            item.id = item.product.id
          }
          item.quantity = 0
          return item
        })
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    sumArr(targetArr, itemName) {
      let sum = 0
      const _arr = []
      targetArr && targetArr.forEach((item) => {
        _arr.push(item[itemName])
      })
      _arr.forEach((val) => {
        sum += Number(val)
      })
      return sum
    },
    getEnumsStatus(name, data) {
      return ENUMS[name][data]
    },
    formatDate(date) {
      return format(date, 'YYYY-MM-DD')
    },
    formatorderPrice(num) {
      return this.$util.data.toThousands(num)
    },
    getPrimary(color) {
      return ENUMS.primaryColor[color]
    },
    cancelDialog() {
      (this.$refs.modalForm).resetValidation()
      this.showModal = false
      this.confirmMemo = ''
    },
    save() {
      if (this.$refs.form.validate()) {
        const vaild = this.items.findIndex(data => data.quantity > 0)
        if (vaild < 0) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Order.distrbuteTips'),
            type: 'warning'
          })
        } else {
          this.showModal = true
        }
      }
    },
    formatSerialNum(str) {
      return this.$util.data.addBrackets(str)
    },
    confirmDialog() {
      if (this.$refs.modalForm.validate()) {
        const error = this.items.filter((f) => {
          return parseInt(f.quantity) > parseInt(f.pendingAllocationQuantity)
        }).length
        if (error > 0) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Order.warningQuantity'),
            type: 'warning'
          })
          return
        }
        const formData = {
          remark: this.confirmMemo,
          shipTime: this.form.shipTime,
          shipDate: this.form.shipDate,
          deliveryTime: this.form.deliveryTime,
          orderId: this.$route.query.id,
          items: this.items.map((pending) => {
            if (pending.quantity && pending.quantity !== 0) {
              return { productId: pending.id, quantity: parseInt(pending.quantity), orderItemId: pending.orderItemId }
            }
          }).filter((f) => {
            return f
          })
        }
        this.sureShipProduct(formData).then(() => {
          this.$router.push({
            name: 'allocation'
          })
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Customer.success'),
            type: 'success'
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped >
.detailWrap {
  span {
    margin-left: 10px;
  }
}
.oRed{
  color: #ff0000 !important;
}
.margin-left-12 {
  margin-left: 12px;
}
.margin-left-20 {
  margin-left: 20px;
}
.margin-right-12 {
  margin-right: 12px;
}
.margin-right-20 {
  margin-right: 20px;
}
.width-100{
  width: 100px;
}
.width-95{
  width: 95px;
}
.width-90{
  width: 90px;
}
.width-80{
  width: 80px;
}
.width-75{
  width: 75px;
}
.width-60{
  width: 60px;
}
.text-right {
  text-align: right;
}
.detail-title{
  margin-bottom: 10px;
}
.width-250{//时间控件的样式
  width: 250px;
  margin-top: -10px
}
.min-width-62{
  min-width:86px;
}
.amount-td {
  position: relative;
  text-align: right;
  font-weight: bold;
  font-size: 14px;
  .amount {
    font-weight: bold;
  }
  .total {
    color: #515151;
  }
}
.sum_pad_table {
  /deep/ .v-datatable {
    thead > tr th:last-child,
    tbody > tr td:last-child {
      padding-right: 68px !important;
    }
  }
}
.refund_pad_table {
  /deep/ .v-datatable {
    thead > tr th:nth-child(2),
    tbody > tr td:nth-child(2) {
      padding-right: 68px !important;
    }
  }
}
/deep/ .table-area {
  padding-top: 0;
}
.flex-fix{
  display: flex;
  align-items: center;
}
.select-width{
  width: 150px;
}
</style>
